export const CHANGE_VEHICLE = 'scenes/VehicleDetail/change_vehicle'
export const CHANGE_USER = 'scenes/VehicleDetail/change_user'
export const CHANGE_POLICY = 'scenes/VehicleDetail/change_policy'
export const CHANGE_DOCUMENTS = 'scenes/VehicleDetail/change_documents'
export const CHANGE_CLAIM = 'scenes/VehicleDetail/change_claim'



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/constants.js